import axios from 'axios';

export type FrontpageError = 'not_found' | 'failed';

export const frontpageError = (error: unknown): FrontpageError =>
  axios.isAxiosError(error) && error.response?.status === 404 ? 'not_found' : 'failed';
